import React from 'react';

const images = {
    clipboard: require('img/icons/clipboard.svg'),
};

export default function FileList({ list = [] }) {
    return (
        <div className="file-list">
            {list.map(({ id, description, url, size }) => (
                <div key={id} className="file-list__item">
                    <div className="file-list__container">
                        <div className="file-list__icon">
                            <img src={images.clipboard} alt="" />
                        </div>
                        <div className="file-list__info">
                            <a href={url} target="_blank" rel="noreferrer" className="file-list__link">
                                {description || url}
                            </a>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
